export default __webpack_public_path__ + "static/media/Prathima@2x.ae34e1da.png";